<script>
    import {acronym} from "../../lib/lib";

    export let acronymName = '';
    export let name = '';
    export let color = '';
    export let colorName = false;
    export let notActive = false;

    export let bold = false;
    export let lg = false;

    let nameColor = '';

    $: {
        nameColor = colorName ? `#${color}` : 'inherit';
    }
</script>

<span class="colored-acronym" class:not-active={ notActive }>
    <span class="color" style="background: #{color};">{ acronym(acronymName) }</span>
    <span class=name class:bold={bold} class:lg={lg} style="color: {nameColor};">{ name }</span>
</span>


<style>
    .colored-acronym {
        position: relative;
        /*display: inline-block;*/
        display: flex;
        align-items: center;
        width: max-content;
    }

    .colored-acronym:after {
        content: " ";
        display: block;
        clear: both;
    }

    .colored-acronym .color {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        top:50%;
        left:0;
        transform:translateY(-50%);
        width: 16px;
        height: 16px;
        font-size: 0.5rem;
        color: #fff;
        border-radius: 50%;
        margin-right: 4px;
    }

    .colored-acronym .name {
        display: block;
        line-height: 1;
        padding-left: 20px;
    }

    .colored-acronym .name.bold {
        font-weight: bold;
    }

    .colored-acronym .name.lg {
        font-size: 16px;
    }
</style>